var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "d-flex flex-row" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("FormSeoConfig", {
                attrs: {
                  data: _vm.seoConfig,
                  loading: _vm.isMutationLoading,
                  loadingData: _vm.isFormLoading,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  "delete-seo-config": _vm.deleteSeoConfig,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                  submit: _vm.formSeoConfigSubmit,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmSeoConfigRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }